/**
 * The in-between screen the auth harness shows while booting, completing a return, or
 * leaving for centralized login. `role="status"` so the message is announced and tests can
 * assert on it by role.
 */
import { Box, CircularProgress, Typography } from '@mui/material';

export function AuthPending({ message }: { message: string }) {
  return (
    <Box
      role="status"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <CircularProgress aria-hidden />
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {message}
      </Typography>
    </Box>
  );
}
